export { default } from "./SimpleDialog";
